const START_SPEAKING_ACTIVITY = 'WEB_CHAT/START_SPEAKING';

export default function startSpeakingActivity() {
  return {
    type: START_SPEAKING_ACTIVITY
  };
}

export { START_SPEAKING_ACTIVITY };
